var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"review-words"}},[_c('PageHeader',{attrs:{"title":"Review Words"}}),_c('WordTable',{attrs:{"review":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }